import React from 'react'

import {HeaderCard, HeaderCenter, Logo} from './BookingsPortalPage.styled'

import {Typography} from '~/components/general/typography/Typography'

type BookingsHeaderProps = {
  logoUrl?: string
  partnerName?: string
  partnerServiceName?: string
  headerSubtitle?: string
  confirmed: boolean
}

export const BookingsHeader: React.FC<BookingsHeaderProps> = ({
  logoUrl,
  partnerName,
  partnerServiceName,
  headerSubtitle,
  confirmed,
}) => (
  <HeaderCard>
    <HeaderCenter>
      {logoUrl && <Logo src={logoUrl} alt="logo" />}
      <Typography size="xxl" weight="bold" textAlign="center">
        {partnerName || '—'}
      </Typography>
      {!confirmed && (
        <Typography weight="medium" textAlign="center">
          {partnerServiceName || headerSubtitle}
        </Typography>
      )}
    </HeaderCenter>
  </HeaderCard>
)
